/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { PraticaOperatoreDetailDTO } from '../model/pratica-operatore-detail-dto';
// @ts-ignore
import { PraticaPunteggioOverrideForm } from '../model/pratica-punteggio-override-form';
// @ts-ignore
import { PraticaPunteggioRicalcolaForm } from '../model/pratica-punteggio-ricalcola-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    GestionePraticheScoringServiceInterface,
    OverrideManualePunteggioPraticaRequestParams,
    RicalcolaPunteggioPraticaRequestParams
} from './gestione-pratiche-scoring.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class GestionePraticheScoringService extends BaseService implements GestionePraticheScoringServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Override manuale operatore del punteggio (bypassa motore). motivo @NotBlank obbligatorio. punteggio_sportello opzionale. Audit PUNTEGGIO_OVERRIDDEN_MANUALMENTE con ScoringManualOverridePayload. Response: 200, 400 motivo blank, 403/404, 409, 422 (G1/G2).
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/punteggio
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public overrideManualePunteggioPratica(requestParameters: OverrideManualePunteggioPraticaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PraticaOperatoreDetailDTO>;
    public overrideManualePunteggioPratica(requestParameters: OverrideManualePunteggioPraticaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PraticaOperatoreDetailDTO>>;
    public overrideManualePunteggioPratica(requestParameters: OverrideManualePunteggioPraticaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PraticaOperatoreDetailDTO>>;
    public overrideManualePunteggioPratica(requestParameters: OverrideManualePunteggioPraticaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling overrideManualePunteggioPratica.');
        }
        const idPratica = requestParameters?.idPratica;
        if (idPratica === null || idPratica === undefined) {
            throw new Error('Required parameter idPratica was null or undefined when calling overrideManualePunteggioPratica.');
        }
        const praticaPunteggioOverrideForm = requestParameters?.praticaPunteggioOverrideForm;
        if (praticaPunteggioOverrideForm === null || praticaPunteggioOverrideForm === undefined) {
            throw new Error('Required parameter praticaPunteggioOverrideForm was null or undefined when calling overrideManualePunteggioPratica.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pratiche/${this.configuration.encodeParam({name: "idPratica", value: idPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/punteggio`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PraticaOperatoreDetailDTO>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: praticaPunteggioOverrideForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Force-recalc del punteggio via motore PraticaScoringService. Audit PUNTEGGIO_RICALCOLATO solo se delta non-zero. Response: 200 + detail, 403/404, 409, 422 (G1/G2).
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/ricalcola-punteggio
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public ricalcolaPunteggioPratica(requestParameters: RicalcolaPunteggioPraticaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PraticaOperatoreDetailDTO>;
    public ricalcolaPunteggioPratica(requestParameters: RicalcolaPunteggioPraticaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PraticaOperatoreDetailDTO>>;
    public ricalcolaPunteggioPratica(requestParameters: RicalcolaPunteggioPraticaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PraticaOperatoreDetailDTO>>;
    public ricalcolaPunteggioPratica(requestParameters: RicalcolaPunteggioPraticaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling ricalcolaPunteggioPratica.');
        }
        const idPratica = requestParameters?.idPratica;
        if (idPratica === null || idPratica === undefined) {
            throw new Error('Required parameter idPratica was null or undefined when calling ricalcolaPunteggioPratica.');
        }
        const praticaPunteggioRicalcolaForm = requestParameters?.praticaPunteggioRicalcolaForm;
        if (praticaPunteggioRicalcolaForm === null || praticaPunteggioRicalcolaForm === undefined) {
            throw new Error('Required parameter praticaPunteggioRicalcolaForm was null or undefined when calling ricalcolaPunteggioPratica.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pratiche/${this.configuration.encodeParam({name: "idPratica", value: idPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricalcola-punteggio`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PraticaOperatoreDetailDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: praticaPunteggioRicalcolaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
